export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

export const GET_AUTHENTICATED_REQUEST = 'GET_AUTHENTICATED_REQUEST';
export const GET_AUTHENTICATED_SUCCESS = 'GET_AUTHENTICATED_SUCCESS';
export const GET_AUTHENTICATED_FAILURE = 'GET_AUTHENTICATED_FAILURE';


export const GET_AUTH_USER_REQUEST = 'GET_AUTH_USER_REQUEST';
export const GET_AUTH_USER_SUCCESS = 'GET_AUTH_USER_SUCCESS';
export const GET_AUTH_USER_FAILURE = 'GET_AUTH_USER_FAILURE';

export const SET_UN_AUTHORIZED_TYPE = 'SET_UN_AUTHORIZED_TYPE';
export const SET_SEEN_ONBOARDING = 'SET_SEEN_ONBOARDING';



